import styled from 'styled-components';

export const StyledCard = styled.div`
  background: ${(props) =>
    props.transparent
      ? 'transparent'
      : props.theme?.colors?.card?.background ||
        (props.theme?.name === 'dark'
          ? 'rgba(255, 255, 255, 0.05)'
          : 'rgba(255, 255, 255, 0.95)')};

  border: ${(props) =>
    props.transparent
      ? 'none'
      : `1px solid ${
          props.theme?.colors?.card?.border ||
          (props.theme?.name === 'dark'
            ? 'rgba(255, 255, 255, 0.1)'
            : 'rgb(226, 232, 240)')
        }`};

  box-shadow: ${(props) =>
    props.transparent
      ? 'none'
      : props.theme?.colors?.card?.shadow ||
        (props.theme?.name === 'dark'
          ? 'rgba(0, 0, 0, 0.2) 0px 1px 3px'
          : 'rgba(0, 0, 0, 0.1) 0px 1px 3px')};

  border-radius: 8px;
  padding: ${(props) =>
    props.noPadding ? '0' : props.compact ? '16px' : '20px'};
  transition: box-shadow 0.15s ease;
  box-sizing: border-box;

  /* Add height: 100% when fullHeight prop is true */
  ${(props) =>
    props.fullHeight &&
    `
    height: 100%;
    display: flex;
    flex-direction: column;
  `}

  /* Add orange left border when accent prop is true */
  ${(props) =>
    props.accent &&
    `
    border-left: 4px solid ${props.theme?.colors?.primary || '#fa4616'};
    padding-left: ${props.noPadding ? '16px' : props.compact ? '16px' : '20px'};
  `}

  &:hover {
    box-shadow: ${(props) =>
      props.transparent
        ? 'none'
        : props.theme?.colors?.card?.shadowHover ||
          (props.theme?.name === 'dark'
            ? 'rgba(0, 0, 0, 0.4) 0px 4px 12px'
            : 'rgba(0, 0, 0, 0.15) 0px 4px 12px')};
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: ${(props) => (props.noMargin ? '0' : '16px')};

  ${(props) =>
    props.withBorder &&
    `
    padding-bottom: 16px;
    border-bottom: 1px solid ${
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0, 0, 0, 0.08)'
    };
  `}
`;

export const CardAccent = styled.div`
  width: 4px;
  height: 24px;
  background: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  border-radius: 2px;
  flex-shrink: 0;
`;

export const CardTitle = styled.h3`
  font-size: ${(props) => {
    switch (props.size) {
      case 'large':
        return '20px';
      case 'small':
        return '16px';
      default:
        return '18px';
    }
  }};
  font-weight: 600;
  color: ${(props) =>
    props.theme?.name === 'dark'
      ? '#ffffff'
      : props.theme?.colors?.blueBlack || '#000033'};
  margin: 0;
  line-height: 1.4;
  width: 100%;
`;
